import { $getSelection, $isRangeSelection } from "lexical";
import {
    INSERT_ORDERED_LIST_COMMAND,
    ListNode,
    REMOVE_LIST_COMMAND,
} from "@lexical/list";
import { $getNearestNodeOfType } from "@lexical/utils";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { ListOrdered } from "lucide-react";

import { useButtonState } from "../useButtonState";

export function NumberedListButton() {
    const [editor] = useLexicalComposerContext();
    const isActive = useButtonState(() => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) return false;
        const anchorNode = selection.anchor.getNode();
        const list = $getNearestNodeOfType(anchorNode, ListNode);
        return list !== null && list.getListType() === "number";
    });

    return (
        <button
            type="button"
            className="rte-toolbar-button"
            data-active={isActive}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() =>
                editor.dispatchCommand(
                    isActive ? REMOVE_LIST_COMMAND : INSERT_ORDERED_LIST_COMMAND,
                    undefined,
                )
            }
            title="Numbered list"
            aria-label="Numbered list"
        >
            <ListOrdered size={16} />
        </button>
    );
}
